// LoadingIndicator.js
import React from 'react';

function LoadingIndicator({ text = 'Loading' }) { // Default text is 'Loading'
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
      <span style={{ fontWeight: '600', marginRight: '10px', color: '#00d4ff', letterSpacing: '0.04em' }}>{text}</span>
      <div style={{ display: 'flex' }}>
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            style={{
              animation: 'dotFlashing 1s infinite linear alternate',
              backgroundColor: '#00d4ff',
              borderRadius: '50%',
              width: '8px',
              height: '8px',
              margin: '0 4px',
              animationDelay: `${i * 250}ms`
            }}
          />
        ))}
      </div>

      <style>
        {`
          @keyframes dotFlashing {
            0% { opacity: 1; }
            50%, 100% { opacity: 0; }
          }
        `}
      </style>
    </div>
  );
}

export default LoadingIndicator;
